import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsModule } from '@geneplanet/ngx-utils/src/lib/analytics';
import { QuestionnaireHostComponent } from '../questionnaire-host/questionnaire-host.component';
import { GpuFormFieldAppearance } from '@geneplanet/ngx-ui/src/lib/form-field';
import { AnalysesService } from 'src/app/analyses/services/analyses.service';
import {
  AnalysesTypesLowercase,
  HabitsConfiguration,
} from 'src/app/analyses/interfaces/analyses.types';
import { retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-add-modal',
  standalone: true,
  imports: [CommonModule, AnalyticsModule, QuestionnaireHostComponent],
  templateUrl: './add-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddModalComponent implements OnInit {
  public id: string;

  protected questionnaires: HabitsConfiguration[];
  protected GpuFormFieldAppearance = GpuFormFieldAppearance;

  constructor(
    public modal: NgbActiveModal,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private analysesService: AnalysesService
  ) {}

  ngOnInit() {
    this.analysesService
      .habitsConfiguration(this.id)
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        this.questionnaires = [response];
        this.cdRef.markForCheck();
      });
  }

  protected onCompleted(data: { id: string }): void {
    this.analysesService
      .getCalculationId(this.id, data.id, AnalysesTypesLowercase.Habits)
      .pipe(retry(5), untilDestroyed(this)) // It might happen, that BE doesn't have result available on first request, but if we retry it will surely be there
      .subscribe((result) => {
        this.router.navigate([
          '/habits/analyses',
          this.id,
          result.result.calculationId,
        ]);
      });
  }
}
